import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/teachers";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(formData) {
  return axios.post(BASE, formData);
}

export function get(id) {
  return axios.get(`${BASE}/${id}`);
}

export function update(id, { field, value }) {
  return axios.patch(`${BASE}/${id}`, { field, value });
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}

export function updateImage(id, formData) {
  return axios.post(`${BASE}/${id}/image`, formData);
}

export function removeImage(id) {
  return axios.delete(`${BASE}/${id}/image`);
}
